const columns = () => ([
  {
    title: 'Display name',
    dataIndex: 'displayName',
    key: 'displayName',
  },
  {
    title: 'Sub name',
    dataIndex: 'subName',
    key: 'subName',
  },
  {
    title: 'Description',
    dataIndex: 'displayText',
    key: 'displayText',
  },
  {
    title: 'Price',
    dataIndex: 'price',
    key: 'price',
  },
  {
    title: 'Additional discount',
    dataIndex: 'additionalDiscount',
    key: 'additionalDiscount',
  },
  {
    title: 'Active',
    dataIndex: 'active',
    key: 'active',
  },
  {
    title: 'Display at checkout',
    dataIndex: 'checkout',
    key: 'checkout',
  },
  {
    title: 'Local',
    dataIndex: 'local',
    key: 'local',
  }, {
    title: 'Recycle',
    dataIndex: 'recycle',
    key: 'recycle',
  },
  {
    title: 'Actions',
    dataIndex: 'actions',
    key: 'actions',
  },
]);

export default columns;
